export default "__VITE_ASSET__C_R$NLUK__"